var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centerPanel"},[_c('ul',{staticClass:"mapNav"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:item.code,class:{active:_vm.navIndex==index},on:{"click":function($event){return _vm.changeNav(index)}}})}),0),_c(_vm.navList[_vm.navIndex].component,{ref:"refComponent",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }